import classNames from 'classnames';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React from 'react';
import './index.scss';

interface EcoShopCardAProps {
    /**
     * 位置
     */
    layout?: 'default' | 'imgL' | 'imgR';
    /**
     * 图片链接
     */
    pc: string;
    /**
     * label
     */
    label?: string;
    /**
     * title
     */
    title?: string;
    /**
     * desc
     */
    desc?: string[];

    /**
     * 更多--链接
     */
    lHref?: string;

    /**
     * 更多--文案
     */
    lChildren?: string;

    /**
     * 样式名
     */
    className?: string;
    /**
     * 埋点信息
     */
    ldataLayer?: DataLayerProps;
    /**
     * 是否禁用按钮
     */
    disabled?: boolean;
}

/**
 * 维护:谢保林
 *
 * 购买卡片
 */
const EcoShopCardA: React.FC<EcoShopCardAProps> = ({ layout = 'imgR', pc, label, title, desc = [], lHref, lChildren, className, ldataLayer, disabled }) => {
    const prefixCls = `eco-shop-card-a`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-layout-${layout}`]: layout,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-img`}>
                <EcoImg pc={pc} />
            </div>
            <div className={`${prefixCls}-msg`}>
                {label && <div className={`${prefixCls}-label`}>{label}</div>}
                {title && <div className={`${prefixCls}-title`}>{title}</div>}
                <ul className={`${prefixCls}-desc-list`}>
                    {desc?.map((descItem: string, index: number) => {
                        return (
                            <li className={`${prefixCls}-desc-item`} key={index}>
                                {descItem}
                            </li>
                        );
                    })}
                </ul>
                <div className={`${prefixCls}-btn-box`}>
                    {!!lHref && !!lChildren && (
                        <>
                            <EcoLink
                                href={lHref}
                                className={`${prefixCls}-btn`}
                                dataLayer={
                                    ldataLayer || {
                                        event: 'uaEvent',
                                        event_name: 'select_product',
                                        button_name: lChildren,
                                        product_name: title,
                                        list_name: 'Product Preview',
                                    }
                                }
                            >
                                {lChildren}
                            </EcoLink>
                        </>
                    )}
                    {disabled && !!lChildren && <span className={`${prefixCls}-link-disabled ${prefixCls}-btn`}>{lChildren}</span>}
                </div>
            </div>
        </div>
    );
};

export default EcoShopCardA;
